import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api, arabicError } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("كلمتا المرور غير متطابقتين"); return; }
    if (pw.length < 6) { toast.error("كلمة المرور قصيرة"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, code, new_password: pw });
      toast.success("تم تغيير كلمة المرور");
      navigate("/login");
    } catch (err) { toast.error(arabicError(err)); }
    finally { setLoading(false); }
  };

  const inputCls = "h-12 w-full rounded-lg border border-[#7AB2B2] bg-white px-4 focus:outline-none focus:ring-2 focus:ring-[#09637E]";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#EBF4F6] p-6" dir="rtl">
      <div className="max-w-md w-full bg-white border border-[#7AB2B2] rounded-2xl p-8" data-testid="reset-page">
        <div className="w-14 h-14 rounded-xl bg-[#EBF4F6] flex items-center justify-center mx-auto mb-4 text-[#09637E]">
          <KeyRound size={28} />
        </div>
        <h2 className="text-2xl font-extrabold text-center text-[#333333] mb-2">تعيين كلمة مرور جديدة</h2>
        <form onSubmit={submit} className="space-y-3 mt-6" data-testid="reset-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="البريد"
            data-testid="reset-email-input" className={inputCls} />
          <input type="text" required inputMode="numeric" maxLength={4} pattern="\d{4}"
            value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
            placeholder="0000" data-testid="reset-code-input"
            className={`${inputCls} text-center text-2xl tracking-[0.5em] font-extrabold`} />
          <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
            placeholder="كلمة المرور الجديدة" data-testid="reset-pw-input" className={inputCls} />
          <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder="تأكيد كلمة المرور" data-testid="reset-confirm-input" className={inputCls} />
          <button type="submit" disabled={loading} data-testid="reset-submit"
            className="h-12 w-full rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-extrabold disabled:opacity-60">
            {loading ? "..." : "تغيير كلمة المرور"}
          </button>
        </form>
        <div className="mt-4 text-center text-sm">
          <Link to="/login" className="inline-flex items-center min-h-[44px] px-2 text-[#09637E] font-bold hover:underline">العودة لتسجيل الدخول</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
